<div class="container" aria-modal="true">
    <div mat-dialog-title class="dialog-title">
        <h1 mat-dialog-title>Update Self</h1>
        <button mat-icon-button aria-label="close dialog" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <form id="filter_form" class="filter_form" [formGroup]="userForm">
            <div class="subtitle"><span class="red">*</span>Indicates required field</div>
            <div class="title-form">USER DETAILS</div>
            <mat-form-field appearance="outline">
                <mat-label>First Name</mat-label>
                <input matInput formControlName="first_name" required cdkFocusInitial>
                <mat-error>Required Field</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="last_name" required cdkFocusInitial>
                <mat-error>Required Field</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Email Address</mat-label>
                <input matInput formControlName="email" required cdkFocusInitial>
                <mat-error>Required Field</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="half-form">
                <mat-label>Phone Number</mat-label>
                <input matInput formControlName="phone_num" cdkFocusInitial placeholder="(XXX) XXX-XXXX"
                    mask="(000) 000-0000">
            </mat-form-field>
            <mat-form-field appearance="outline" *ngIf="data.user_type == 'User'">
                <mat-label>Agency</mat-label>
                <mat-select formControlName="agency_id" required
                    (selectionChange)="updateValidators($event.value, 'agency_id')">
                    @for (agency of agency_list; track agency_list) {
                    <mat-option [value]="agency.value">{{agency.text}}</mat-option>
                    }
                </mat-select>
                <mat-error>Required Field</mat-error>
            </mat-form-field>
            <div class="location-info">
                <div class="subtitle" *ngIf="(userForm.controls['agency_id'].getRawValue() ?? 0) == 0">
                    <span class="red">*</span><b>Organizational Unit Location</b>
                </div>
                <div class="title-form" *ngIf="(userForm.controls['agency_id'].getRawValue() ?? 0) != 0">Location
                    <span class="gray-text">(Closest Forest Service Office)</span>
                </div>
                <mat-radio-group required formControlName="location_id" class="radio-buttons"
                    (change)="updateValidators($event.value, 'location_id')">
                    <mat-radio-button [value]="0" color="primary" class="radio-button">Forest Office</mat-radio-button>
                    <mat-radio-button [value]="1" color="primary">Regional Office</mat-radio-button>
                    <mat-radio-button [value]="2" color="primary"
                        *ngIf="userForm.controls['agency_id'].getRawValue() == 0">Washington Office</mat-radio-button>
                </mat-radio-group>
                <div class="sub-location"
                    *ngIf="userForm.controls['location_id'].getRawValue() == 0 || userForm.controls['location_id'].getRawValue() == 1">
                    <mat-form-field appearance="outline">
                        <mat-label>Region</mat-label>
                        <mat-select formControlName="region" required (selectionChange)="regionChanged()">
                            @for (region of regions; track region) {
                            <mat-option [value]="region">{{region}}</mat-option>
                            }
                        </mat-select>
                        <mat-error>Required Field</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" *ngIf="userForm.controls['location_id'].getRawValue() == 0"
                        style="width: 50%">
                        <mat-label>Forest Name</mat-label>
                        <input #forest matInput required formControlName="forest_name" [matAutocomplete]="auto"
                            (input)="filter()" (focus)="clearForest()">
                        <mat-autocomplete requireSelection #auto="matAutocomplete"
                            (optionSelected)="forestNameSelected($event)">
                            @for (name of filtered_forest_names | async; track name) {
                            <mat-option [value]="name">{{name | forest_filter}}</mat-option>
                            }
                        </mat-autocomplete>
                        <mat-error>Required Field</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="location-info" *ngIf="(userForm.controls['agency_id'].getRawValue() ?? 0) == 0">
                <div class="subtitle" style="margin-top: 10px;">
                    <span class="red">*</span><b>Duty Station Location</b>
                </div>
                <mat-radio-group required formControlName="duty_location_id" class="radio-buttons"
                    (change)="updateValidators($event.value, 'duty_location_id')">
                    <mat-radio-button [value]="0" color="primary" class="radio-button">Forest Office</mat-radio-button>
                    <mat-radio-button [value]="1" color="primary">Regional Office</mat-radio-button>
                    <mat-radio-button [value]="2" color="primary"
                        *ngIf="userForm.controls['agency_id'].getRawValue() == 0">Washington Office</mat-radio-button>
                </mat-radio-group>
                <div class="sub-location"
                    *ngIf="userForm.controls['duty_location_id'].getRawValue() == 0 || userForm.controls['duty_location_id'].getRawValue() == 1">
                    <mat-form-field appearance="outline">
                        <mat-label>Region</mat-label>
                        <mat-select formControlName="duty_region" required (selectionChange)="regionChanged_duty()">
                            @for (region of regions; track region) {
                            <mat-option [value]="region">{{region}}</mat-option>
                            }
                        </mat-select>
                        <mat-error>Required Field</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                        *ngIf="userForm.controls['duty_location_id'].getRawValue() == 0" style="width: 50%">
                        <mat-label>Forest Name</mat-label>
                        <input #forest matInput required formControlName="duty_forest_name" [matAutocomplete]="auto"
                            (input)="filter_duty()" (focus)="clearForest_duty()">
                        <mat-autocomplete requireSelection #auto="matAutocomplete"
                            (optionSelected)="forestNameSelected_duty($event)">
                            @for (name of filtered_forest_names_duty | async; track name) {
                            <mat-option [value]="name">{{name | forest_filter}}</mat-option>
                            }
                        </mat-autocomplete>
                        <mat-error>Required Field</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="positions">
                <div class="title-form">POSITIONS<button class="usa-button usa-button--secondary"
                        (click)="addPosition()">
                        <fa-icon [icon]="faPlus"></fa-icon>Add Position
                    </button></div>
                @for (position of PositionList; track position; let i = $index) {
                <button class="position-remove" (click)="removePosition(position.item)" *ngIf="(PositionList.length > 1) || data.user_type == 'Coordinator'"
                    matTooltip="Remove" matTooltipClass="tooltipClass">
                    <mat-icon>close</mat-icon>
                </button>
                <app-location-filter [(location)]='PositionList[i]' [regions]='regions' [roles]="roles"
                    [user_type]="'Coordinator'" [BAER_role_type]="BAER_role_type"
                    [org_location]="userForm.controls['location_id'].getRawValue()"
                    [org_region]="userForm.controls['region'].getRawValue()"
                    [org_forest]="userForm.controls['forest_name'].getRawValue()"
                    [duty_location]="userForm.controls['duty_location_id'].getRawValue()"
                    [duty_region]="userForm.controls['duty_region'].getRawValue()"
                    [duty_forest]="userForm.controls['duty_forest_name'].getRawValue()"></app-location-filter>

                }
            </div>
        </form>
        <app-remove-positions [user]="data.user" [updateUser]="updateUser" [positionList]="deletePositionList"></app-remove-positions>
    </mat-dialog-content>
    <div mat-dialog-actions>
        <div class="button-row">
            <button class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
            <button class="usa-button" [disabled]="!userForm.valid" (click)="saveUser()">Update</button>
        </div>
    </div>
</div>